export default __webpack_public_path__ + "static/media/peaks.bdaccbb3.svg";